import React from 'react';
import './AddStepButton.css';

const AddStepButton = ({ onClick, isFirst }) => {
    return (
        <div className={`add-step-container ${isFirst ? 'first' : ''}`}>
            <div className="add-step-line"></div>
            <button 
                className="add-step-button"
                onClick={onClick}
                title="Add step"
            >
                +
            </button>
            <div className="add-step-line"></div>
        </div>
    );
};

export default AddStepButton; 